<template>
  <div class="user_page">
    <h3 class="title-page">{{ $t("productAcceptance") }}</h3>
    <div>
      <div class="admin_container">
        <div class="division_main">
          <TableWithFilter
            @update:sort="getOrdersWithLoading"
            fixed-header
            :headers="headers"
            :items="orders"
            :options.sync="tableOptions"
            handler-value="numb"
            item-key="id"
            :page="tableOptions.page"
          >
            <template #filter.parentNumb>
              <div class="pa-1">
                <custom-input-text
                  only="number"
                  class="user_input no-margin"
                  v-model="orderListFilter.numbSearch"
                  @input="onChangeFilter"
                  clearable
                />
              </div>
            </template>
            <template #item.action="{ item }">
              <VTooltip color="#fff" left nudge-right="10" nudge-top="35">
                <template v-slot:activator="{ on, attrs }">
                  <!--If you add to 'btn_33' element 'disabled' class. it is disabled element  -->
                  <VBtn
                    v-bind="attrs"
                    v-on="on"
                    class="new_style"
                    :to="{
                      name: 'division-product-accept',
                      params: { id: item.id },
                    }"
                  >
                    <VueIcon icon="newEyeIcon"></VueIcon>
                  </VBtn>
                </template>
                <span>{{ $t("send") }}</span>
              </VTooltip>
            </template>
            <template #item.productAttrs="{ item }">
              {{ item.productAttrs && item.productAttrs.join(" || ") }}
            </template>
            <template #item.itemSendDate="{ item: { itemSendDate } }">
              {{ itemSendDate | fullTimeParse }}
            </template>
            <template #item.contractDate="{ item: { contractDate } }">{{
              contractDate | fullTimeParse
            }}</template>
            <template #item.itemConclusionDate="{ item }"
              >{{ item.itemConclusionDate | fullTimeParse }}
            </template>
          </TableWithFilter>
          <VuePagination
            @update:limit="
              (limit) => {
                tableOptions.limit = limit;
                tableOptions.page = 1;
                changePage();
              }
            "
            v-model="tableOptions.page"
            :length="lastPage"
            @input="changePage"
            go-to
            :limit="tableOptions.limit"
          />
        </div>
      </div>
    </div>
    <ProductAcceptanceDialog
      ref="productAcceptanceDialogRef"
    ></ProductAcceptanceDialog>
  </div>
</template>

<script>
import {
  debounce,
  getQueryByKey,
  makerPagination,
  shallowEqual,
  trueSet,
} from "@/utils/pureFunctions";
import TableWithFilter from "@/components/ui/table/TableWithFilter";
import VuePagination from "@/components/ui/vue-pagination/VuePagination.vue";
import ProductAcceptanceDialog from "@/components/division/ProductAcceptanceDialog.vue";

const ORDER_LIST_FILTER = {
  numbSearch: null,
};

export default {
  components: {
    VuePagination,
    TableWithFilter,
    ProductAcceptanceDialog,
  },
  data() {
    return {
      ready: false,
      tableOptions: {
        page: 1,
        sortBy: "numb",
        sortDirection: false,
      },
      orderListFilter: {
        ...ORDER_LIST_FILTER,
      },
      lastPage: 0,
      dialog: false,
      orders: [],
    };
  },
  computed: {
    headers() {
      return [
        {
          value: "parentNumb",
          text: this.$t("requestNumber"),
        },
        {
          value: "productName",
          text: this.$t("productName"),
        },
        {
          value: "itemNumb",
          text: this.$t("orderRequestItemNumber"),
        },

        {
          value: "count",
          text: this.$t("count"),
        },
        {
          value: "itemSendDate",
          text: this.$t("sendDate"),
        },
        {
          value: "itemConclusionDate",
          text: this.$t("itemConclusionDate"),
        },
        {
          value: "contractDate",
          text: this.$t("contractDate"),
        },
        {
          value: "action",
          text: this.$t("action"),
        },
        {
          value: "productAttrs",
          text: this.$t("attributes"),
        },
      ];
    },
  },
  methods: {
    async changePage() {
      await this.$router.replace({
        query: { ...this.tableOptions, ...this.orderListFilter },
      });
      await this.getOrdersWithLoading();
    },
    onChangeFilter: debounce(function () {
      let query = { ...this.$route.query };
      if (query.sortDirection)
        query.sortDirection = trueSet(query.sortDirection);
      if (query.page) query.page = +query.page;
      const currentQuery = { ...this.tableOptions, ...this.orderListFilter };
      if (!shallowEqual(currentQuery, query)) {
        if (this.tableOptions.page !== 1) {
          this.tableOptions.page = 1;
        }
        this.$router
          .replace({ query: currentQuery })
          .catch((err) => console.warn(err));
        this.getOrdersWithLoading();
      }
    }, 300),
    async getListOrderItems() {
      let params = {
        ...this.tableOptions,
        ...this.orderListFilter,
        limit: 10,
        page: this.tableOptions.page - 1,
      };
      try {
        const {
          data: { data, total: orderTotal },
        } = await this.$http.get("/given-products/list-order-items", {
          params,
        });
        this.orders = data.map((item) => {
          return item;
        });

        this.lastPage = makerPagination({
          total: orderTotal,
          limit: params.limit,
        }).lastPage;
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
    async getOrdersWithLoading() {
      this.showLoading();
      await this.getListOrderItems();
      this.clearLoading();
    },
  },
  async created() {
    let query = { ...this.$route.query };
    if (query.page && !isNaN(query.page)) query.page = +query.page;
    if (query.sortDirection) query.sortDirection = trueSet(query.sortDirection);
    this.tableOptions = getQueryByKey(this.tableOptions, query);
    this.orderListFilter = getQueryByKey(ORDER_LIST_FILTER, query);
    this.showLoading();
    try {
      await this.getListOrderItems();
      this.ready = true;
    } catch (e) {
      this.setResponseError({ error: e });
    } finally {
      this.clearLoading();
    }
  },
};
</script>
